<template>
  <div class="subscriptions-view-toggler">
    <div class="subscriptions-view-toggler__wrapper">
      <button
        class="btn btn--responsive btn--bold subscriptions-view-toggler__btn"
        data-testid="individuals-selector"
        :class="
          !isTeamsViewSelected
            ? 'btn--primary'
            : 'btn--secondary subscriptions-view-toggler__btn--inactive'
        "
        @click="setTemplate(b2cView)"
      >
        Personal
      </button>
      <button
        class="btn btn--responsive btn--bold subscriptions-view-toggler__btn"
        data-testid="teams-selector"
        :class="
          isTeamsViewSelected
            ? 'btn--primary'
            : 'btn--secondary subscriptions-view-toggler__btn--inactive'
        "
        @click="setTemplate(b2bView)"
      >
        Business
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'

export default {
  name: 'SubscriptionsViewToggler',
  emits: ['subscription-view-teams'],
  data() {
    return {
      b2bView: CONSTANTS.SHOP_VIEW.B2B_OFFER,
      b2cView: CONSTANTS.SHOP_VIEW.B2C_OFFER,
    }
  },
  computed: {
    ...mapGetters({
      isTeamsViewSelected: 'app/isB2BOfferView',
    }),
  },
  created() {
    if (
      this.subscriptionsViewSelected &&
      [this.b2cView, this.b2bView].includes(this.subscriptionsViewSelected)
    ) {
      this.setTemplate(this.subscriptionsViewSelected)
    }
  },
  methods: {
    ...mapActions({
      setSubscriptionView: 'app/setSubscriptionView',
    }),
    setTemplate(templateToShow) {
      this.setSubscriptionView(templateToShow)
    },
  },
}
</script>

<style lang="scss" scoped>
.subscriptions-view-toggler {
  display: flex;
  justify-content: center;
  width: 100%;
  @include tablet {
    width: auto;
  }
  &__wrapper {
    background: var(--black-1);
    border-radius: 10px;
    border: 2px solid var(--light-purple);
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    &:hover {
      background: var(
        --mid-gray-translucid-gradient-two,
        linear-gradient(140deg, rgba(187, 188, 199, 0.7) 0%, rgba(187, 188, 199, 0) 100%)
      );
    }
    &:active {
      background: var(--black-1);
    }
    @include desktop {
      width: auto;
    }
  }
  &__btn {
    &:active {
      color: var(--white);
      background: none;
      opacity: 1;
    }
    &--inactive {
      opacity: 0.8;
    }
  }
  :global(.btn--secondary) {
    border: none;
  }
  @include tablet {
    :global(.btn) {
      width: 180px;
    }
  }
}
</style>
